import { render, staticRenderFns } from "./transformationsFromToModal.vue?vue&type=template&id=c7c0fb5c&"
import script from "./transformationsFromToModal.vue?vue&type=script&lang=js&"
export * from "./transformationsFromToModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports